import { Routes, Route } from 'react-router-dom';
import { SBCaaS } from '../edit/Sbcaas';
import { SRT } from '../edit/SRT';
import { OC } from '../edit/OC';
import { ZoomAuthEdit } from '../edit/Zoom';
import WebexAuthServiceEdit from '../edit/WebexAuthServiceEdit';
import EditAzureService from '../ServiceWizard/Azure/EditAzureService';
import DirectRouting from 'pages/services/provisionedservices/DirectRouting';
import GCCHEditService from 'pages/services/provisionedservices/GCCHEditService';
import AppAuthEdit from 'pages/services/provisionedservices/AppAuth';

// TPM
import TPM from 'pages/services/provisionedservices/TPM';

import ProtectedNoMatch from 'components/v4/ProtectedNoMatch';
import path from '@/routes/constants';
import OCCEditService from '../ServiceDashboard/Services/OCC/OccEditService';
import ActivateServiceUsers from 'pages/services/serviceprofiles/vendorDefined/users';
import ActivateServiceNumbers from 'pages/services/serviceprofiles/vendorDefined/numbers';
import { DefinedAttributesProvider } from 'pages/services/serviceprofiles/vendorDefined/DefinedAttributesContext';
import EditVendorDefined from '../ServiceDashboard/Services/VendorDefined/EditVendorDefined';
import { EightByEightAuthEdit } from 'pages/services/new/edit/EightByEight';
import EightByEightLicences from 'pages/services/new/edit/EightByEightLicences';
import EightByEightServiceView from 'pages/services/new/edit/EightByEightServiceView';
import EightByEightServiceEdit from 'pages/services/new/edit/EightByEightServiceEdit';

// NOTE: some pages has no create route as they're in file with mode change
export default function ServiceRoutes() {
    const {
        SBCAAS,
        DIRECT_ROUTING,
        OPERATOR_CONNECT,
        OPERATOR_CONNECT_CONFERENCE,
        TEAM_PHONE_MOBILE,
        AZURE_CONNECT_SERVICE,
        APP_AUTH,
        EDIT,
        CREATE,
        VENDOR_DEFINED,
        OPERATOR_PLATFORM,
        SERVICES_VD_USERS,
        SERVICES_VD_NUMBERS,
        ZOOM_AUTH,
        EIGHTBYEIGHT,
        EIGHTBYEIGHT_AUTH,
        GCC_HIGH,
        WEBEX_AUTH,
        SRT: SRT_PATH,
    } = path;
    return (
        <>
            <Routes>
                {/* SBC as a service */}
                <Route path={SBCAAS}>
                    <Route path={EDIT} element={<SBCaaS />} />
                </Route>
                {/* Operating Connect */}
                <Route path={OPERATOR_CONNECT}>
                    <Route path={EDIT} element={<OC />} />
                </Route>
                {/* OCC */}
                <Route path={OPERATOR_CONNECT_CONFERENCE}>
                    <Route path={EDIT} element={<OCCEditService />} />
                </Route>
                {/* Direct Routing */}
                <Route path={DIRECT_ROUTING}>
                    <Route
                        path={EDIT}
                        element={<DirectRouting mode="edit" />}
                    />
                </Route>
                {/* App Auth */}
                <Route path={APP_AUTH}>
                    <Route path={EDIT} element={<AppAuthEdit mode="edit" />} />
                </Route>
                {/* Azure */}
                <Route path={AZURE_CONNECT_SERVICE}>
                    <Route
                        path={CREATE}
                        element={<EditAzureService mode="ADD" />}
                    />
                    <Route
                        path={EDIT}
                        element={<EditAzureService mode="EDIT" />}
                    />
                </Route>
                {/* Tpm */}
                <Route path={TEAM_PHONE_MOBILE}>
                    {/* Hide TPM old route */}
                    <Route index element={<ProtectedNoMatch />} />
                    <Route path={EDIT} element={<TPM mode="EDIT" />} />
                </Route>
                {/* Vendor Defined */}
                <Route path={VENDOR_DEFINED}>
                    <Route
                        path={EDIT}
                        element={
                            <DefinedAttributesProvider>
                                <EditVendorDefined />
                            </DefinedAttributesProvider>
                        }
                    />
                    <Route
                        path={SERVICES_VD_USERS}
                        element={<ActivateServiceUsers />}
                    />
                    <Route
                        path={SERVICES_VD_NUMBERS}
                        element={<ActivateServiceNumbers />}
                    />
                </Route>

                {/* Vendor Defined */}
                <Route path={VENDOR_DEFINED}>
                    <Route
                        path={EDIT}
                        element={
                            <DefinedAttributesProvider>
                                <EditVendorDefined />
                            </DefinedAttributesProvider>
                        }
                    />
                    <Route
                        path={SERVICES_VD_USERS}
                        element={<ActivateServiceUsers />}
                    />
                    <Route
                        path={SERVICES_VD_NUMBERS}
                        element={<ActivateServiceNumbers />}
                    />
                </Route>

                <Route path={OPERATOR_PLATFORM}>
                    <Route
                        path={EDIT}
                        element={
                            <DefinedAttributesProvider>
                                <EditVendorDefined />
                            </DefinedAttributesProvider>
                        }
                    />
                    <Route
                        path={SERVICES_VD_USERS}
                        element={<ActivateServiceUsers />}
                    />
                    <Route
                        path={SERVICES_VD_NUMBERS}
                        element={<ActivateServiceNumbers />}
                    />
                </Route>
                <Route path={ZOOM_AUTH}>
                    <Route path={EDIT} element={<ZoomAuthEdit />} />
                </Route>
                <Route path={EIGHTBYEIGHT}>
                    <Route
                        path=":id/edit"
                        element={<EightByEightServiceEdit />}
                    />
                    <Route
                        path=":id/licences"
                        element={<EightByEightLicences />}
                    />
                    <Route
                        path=":id/view"
                        element={<EightByEightServiceView />}
                    />
                </Route>
                <Route path={EIGHTBYEIGHT_AUTH}>
                    <Route path={EDIT} element={<EightByEightAuthEdit />} />
                </Route>
                <Route path={GCC_HIGH}>
                    <Route
                        path={EDIT}
                        element={<GCCHEditService mode="edit" />}
                    />
                </Route>
                <Route path={WEBEX_AUTH}>
                    <Route path={EDIT} element={<WebexAuthServiceEdit />} />
                </Route>
                {/* SRT */}
                <Route path={SRT_PATH}>
                    <Route path={EDIT} element={<SRT />} />
                </Route>
                {/* No Match */}
                <Route path="*" element={<ProtectedNoMatch />} />
            </Routes>
        </>
    );
}
